import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import type { AddressData, SetCurrentStore } from './types';

export function useAddressForm(defaultValues: AddressData, setCurrentStore: SetCurrentStore) {
  const { control, reset } = useForm<AddressData>({ defaultValues });

  const handleAddressSelect = useCallback((data: AddressData) => {
    reset(data);
    setCurrentStore(data);
  }, [reset, setCurrentStore]);

  const handleFieldChange = useCallback((field: keyof AddressData, value: string) => {
    setCurrentStore((prev) => ({ ...prev, [field]: value }));
  }, [setCurrentStore]);

  return { control, handleAddressSelect, handleFieldChange };
}
